<script>
export default {
  props: {
    location: String,
    temperature: Number,
    humidity: Number,
    wind: Number
  },
  data() {
    return {
      count: 0
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-header">{{ location }}</div>
    <div class="metrics">
      <div class="metric">
        <span class="metric-label">Temperature</span>
        <span class="metric-value">{{ temperature }}°C</span>
      </div>
      <div class="metric">
        <span class="metric-label">Humidity</span>
        <span class="metric-value">{{ humidity }}%</span>
      </div>
      <div class="metric">
        <span class="metric-label">Wind</span>
        <span class="metric-value">{{ wind }} m/s</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  border-radius: 12px;
  border: 1px solid #99d4fe;
  background-color: #e0f2ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 12px 14px;
  cursor: pointer;
}

.card-header {
  font-size: 15px;
  font-weight: 700;
  color: #005c9e;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #99d4fe;
}

.metrics {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.metric-label {
  font-size: 12px;
  color: #008ffb;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.metric-value {
  font-size: 14px;
  font-weight: 600;
  color: #003d68;
}

/* ---------- Dark theme (class lives on ancestor #main_div in App.vue) ---------- */
#main_div.dark .card {
  border-color: #24344f;
  background-color: #1e2d47;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

#main_div.dark .card-header {
  color: #8ec5f0;
  border-bottom-color: #24344f;
}

#main_div.dark .metric-label {
  color: #4aa8f0;
}

#main_div.dark .metric-value {
  color: #e6f3fd;
}
</style>